import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/button/Button';
import Card from '@/components/common/card/Card';
import AlertMessage from '@/components/layout/message/AlertMessage';
import styles from '../../VirtualSimulationPresenter.module.css';
import type { breakScreenProps } from './types.props';


const BreakScreen: React.FC<breakScreenProps> = ({
    nextSessionNumber,
    durationMinutes,
    onStartNextSession,
    isSubmitting
}) => {
    const navigate = useNavigate();

    return (
        <div className={styles.centerContainer}>
            <Card className={styles.startCard}>
                <div className={styles.iconWrapper}>
                    <svg className={styles.breakIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
                <h1>¡Sesión {nextSessionNumber - 1} finalizada!</h1>
                <p
                    className={styles.subtitle}
                >
                    Puedes tomar un descanso. Cuando estés listo, comienza la siguiente sesión.
                </p>
                <p
                    className={styles.durationInfo}
                >
                    La Sesión {nextSessionNumber} tendrá una duración de <strong>{durationMinutes} minutos</strong>.
                </p>
                <AlertMessage type="warning" title="¡Atención!">
                    El temporizador comenzará en cuanto inicies la sesión y no se detendrá.
                </AlertMessage>
                <div className={styles.buttonGroup}>
                    <Button
                        variant="secondary"
                        onClick={() => navigate('/student-home')}
                    >
                        Volver al panel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={onStartNextSession}
                        isLoading={isSubmitting}
                    >
                        Iniciar sesión {nextSessionNumber}
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default BreakScreen;
